import {Menu} from "./inc/Menu.js";
import {LanguageMenu} from "./inc/LanguageMenu.js";

window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("#header").forEach((elm) => new Menu(elm));
    new LanguageMenu(document.querySelector(".nav-menu > ul > .wpml-ls-item"));
})
